const checkRtwText = strng => {
  const regex = RegExp(/["~\\\[\]\^\|]+/g);
  return regex.test(strng);
};
export default checkRtwText;
